export function stripLocalTime(str){
    if (str.length === 0) return str;
    
    const validDate = str.indexOf('-');
    
    if (validDate === -1) return str; 
    
    const parts = str.split('-');
    const day = parts[2].substring(0, 2);
    
    return new Date(parts[0], parts[1] - 1, day);
  }